import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import MuiHeader from "../../components/MuiHeader";
import { toast, ToastContainer } from "react-toastify";
import * as XLSX from "xlsx";
import {
  getOverallDashboard,
  saveOverallDashboard,
  getDashboardMonthly,
  saveDashboardMonthly,
  getRemoteInstructionsWeeklyData,
  saveRemoteInstructionsWeeklyData,
  getMonthlyUniqueUsers,
  saveMonthlyUniqueUsers,
  getRemoteInstructionsMonthlyData,
  saveRemoteInstructionsMonthlyData,
  getWhatsappBotMonthlyData,
  saveWhatsappBotMonthlyData,
  getWhatsappBotWeeklyData,
  saveWhatsappBotWeeklyData,
  getSchoolwiseData,
  getSchoolwisePerformanceData,
  getRetentionMetricsData,
  saveSchoolwiseData,
  saveSchoolwisePerformanceData,
  saveRetentionMetricsData,
  getStaticDistBlocks,
  saveStaticDistBlocks,
  saveAnganwadiwiseData,
  saveAnganwadiWisePerformanceData,
  getAnganwadiwiseData,
  getAnganwadiwisePerformanceData,
} from "./PrakashakStatics.thunk";

const tabArray = [
  {
    value: "dashboard",
    label: "Overall Dashboard",
  },
  {
    value: "dashboard_monthly",
    label: "Dashboard Monthly",
  },
  {
    value: "remote_instructions_monthwise",
    label: "Remote Instructions(Month)",
  },
  {
    value: "remote_instructions_weekwise",
    label: "Remote Instructions(Week)",
  },
  {
    value: "monthly_unique",
    label: "Monthly Unique Users (overall Graph)",
  },
  {
    value: "whatsapp_chatbot_monthly",
    label: "Whatsapp Chatbot(monthly)",
  },
  {
    value: "whatsapp_chatbot_weekly",
    label: "Whatsapp Chatbot(weekly)",
  },
  {
    value: "school_wise",
    label: "Schoolwise ",
  },
  {
    value: "school_wise_performance",
    label: "Schoolwise Performance",
  },
  {
    value: "anganwadi_wise",
    label: "Anganwadiwise ",
  },
  {
    value: "anganwadi_wise_performance",
    label: "Anganwadiwise Performance ",
  },
  {
    value: "retention_metrics",
    label: "Retention Metrics",
  },
  {
    value: "dist_blocks",
    label: "District Blocks",
  },
];

const PrakashakStatics = () => {
  const [selectedTab, setSelectedTab] = useState("");
  const [file, setFile] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const [isDraggedOver, setIsDraggedOver] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [allData, setAllData] = useState([]); //This will hold my data coming from getApi
  const [fileCount, setFileCount] = useState(null);

  //Dynamic function for the getApi calls
  const handleApiCall = (apiCall) => {
    apiCall()
      .then((response) => {
        if (response.status === 200) {
          setAllData(response?.data); // Update allData with the response data
          setFile(null);
          setExcelData(null);
        }
      })
      .catch((error) => {
        handleApiError(error);
      });
  };

  //Dynamic functions for save API calls
  const handleSaveApiCall = (apiCallSave, body, apiCallGet) => {
    apiCallSave(body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setTimeout(() => {
            setLoadingSave(false);
          }, 1400);
          handleApiCall(apiCallGet);
        }
      })
      .catch((error) => {
        handleApiError(error);
      });
  };

  //This is my reusable function to handle API errors
  const handleApiError = (error) => {
    setLoadingSave(false);
    let errorMessage = "An error occurred";
    if (error.response) {
      const { status, data } = error.response;
      errorMessage = data?.message || `Error: ${status}`;
    } else if (error.request) {
      errorMessage = "No response received from the server.";
    } else {
      errorMessage = `Error: ${error.message}`;
    }
    toast.error(errorMessage);
  };

  const tabApiMapping = {
    dashboard: getOverallDashboard,
    dashboard_monthly: getDashboardMonthly,
    remote_instructions_weekwise: getRemoteInstructionsWeeklyData,
    remote_instructions_monthwise: getRemoteInstructionsMonthlyData,
    monthly_unique: getMonthlyUniqueUsers,
    whatsapp_chatbot_monthly: getWhatsappBotMonthlyData,
    whatsapp_chatbot_weekly: getWhatsappBotWeeklyData,
    school_wise: getSchoolwiseData,
    school_wise_performance: getSchoolwisePerformanceData,
    retention_metrics: getRetentionMetricsData,
    dist_blocks: getStaticDistBlocks,
    anganwadi_wise: getAnganwadiwiseData,
    anganwadi_wise_performance: getAnganwadiwisePerformanceData,
  };

  const handleTabChange = (e) => {
    setSelectedTab(e.target.value);
    setAllData([]);
    setFile(null);
    const apiCall = tabApiMapping[e.target.value];
    if (apiCall) handleApiCall(apiCall);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggedOver(true);
  };

  const handleDragLeave = () => {
    setIsDraggedOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggedOver(false);
    const droppedFile = e.dataTransfer.files[0];

    if (
      droppedFile &&
      droppedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      processExcelFile(droppedFile);
      setFile(droppedFile);
      toast.success("File uploaded successfully!");
    } else {
      toast.error("Please upload a valid Excel file (.xlsx)");
    }
  };

  const handleFileInputChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (
      uploadedFile &&
      uploadedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      processExcelFile(uploadedFile);
      setFile(uploadedFile);
      toast.success("File added successfully!");
    } else {
      toast.error("Please upload a valid Excel file (.xlsx)");
    }
  };

  const expectedHeaders =
    selectedTab === "remote_instructions_monthwise"
      ? [
          "year",
          "month",
          "non_smartphone_users",
          "non_smartphone_boys",
          "non_smartphone_girls",
          "lastUpdated",
        ]
      : selectedTab === "remote_instructions_weekwise"
      ? [
          "year",
          "month",
          "week",
          "new_non_smartphone_users",
          "new_activated_non_smartphone_users",
          "active_non_smartphone_users",
          "ts_0to1_users",
          "ts_0to1_avgTs",
          "ts_2to15_users",
          "ts_2to15_avgTs",
          "ts_16to30_users",
          "ts_16to30_avgTs",
          "ts_31to45_users",
          "ts_31to45_avgTs",
          "ts_45plus_users",
          "ts_45plus_avgTs",
          "lastUpdated",
        ]
      : selectedTab === "dashboard_monthly"
      ? [
          "year",
          "month",
          "week",
          "new_schools",
          "new_students",
          "new_anganwadis",
          "new_boys",
          "new_girls",
          "new_activated_students",
          "total_active_students",
          "active_students_boys",
          "active_students_girls",
          "ts_0to1_users",
          "ts_0to1_avgTs",
          "ts_2to15_users",
          "ts_2to15_avgTs",
          "ts_16to30_users",
          "ts_16to30_avgTs",
          "ts_31to45_users",
          "ts_31to45_avgTs",
          "ts_45plus_users",
          "ts_45plus_avgTs",
          "lastUpdated",
        ]
      : selectedTab === "dashboard"
      ? [
          "total_clusters",
          "total_schools",
          "total_sectors",
          "total_anganwadis",
          "registered_students",
          "registered_boys",
          "registered_girls",
          "activated_students",
          "active_students",
        ]
      : selectedTab === "monthly_unique"
      ? [
          "year",
          "month",
          "userType",
          "uniqueBoys",
          "uniqueGirls",
          "uniqueUsers",
          "lastUpdated",
        ]
      : selectedTab === "whatsapp_chatbot_monthly"
      ? [
          "year",
          "month",
          "smartphone_users",
          "smartphone_boys",
          "smartphone__girls",
          "lastUpdated",
        ]
      : selectedTab === "whatsapp_chatbot_weekly"
      ? [
          "year",
          "month",
          "week",
          "new_smartphone_users",
          "new_activated_smartphone_users",
          "active_smartphone_users",
          "ts_0to1_avgTs",
          "ts_2to15_users",
          "ts_2to15_avgTs",
          "ts_16to30_users",
          "ts_16to30_avgTs",
          "ts_31to45_users",
          "ts_31to45_avgTs",
          "ts_45plus_users",
          "ts_45plus_avgTs",
          "lastUpdated",
        ]
      : selectedTab === "school_wise"
      ? [
          "district",
          "block",
          "cluster",
          "school_name",
          "total_students",
          "class1_students",
          "class2_students",
          "class3_students",
          "class4_students",
          "class5_students",
          "activated_users",
          "active_users",
          "smartphone_users",
          "non_smartphone_users",
          "lastUpdated",
        ]
      : selectedTab === "school_wise_performance"
      ? [
          "district",
          "block",
          "cluster",
          "school_name",
          "year",
          "month",
          "week",
          "ts_0to1_users",
          "ts_0to1_avgTs",
          "ts_2to15_users",
          "ts_2to15_avgTs",
          "ts_16to30_users",
          "ts_16to30_avgTs",
          "ts_31to45_users",
          "ts_31to45_avgTs",
          "ts_45plus_users",
          "ts_45plus_avgTs",
          "lastUpdated",
        ]
      : selectedTab === "retention_metrics"
      ? [
          "year",
          "month",
          "activated_users",
          "retained_jan",
          "retained_feb",
          "retained_mar",
          "retained_apr",
          "retained_may",
          "retained_jun",
          "retained_jul",
          "retained_aug",
          "retained_sep",
          "retained_oct",
          "retained_nov",
          "retained_dec",
          "active_jan",
          "active_feb",
          "active_mar",
          "active_apr",
          "active_may",
          "active_jun",
          "active_jul",
          "active_aug",
          "active_sep",
          "active_oct",
          "active_nov",
          "active_dec",
          "lastUpdated",
        ]
      : selectedTab === "dist_blocks"
      ? [
          "district",
          "block",
          "cluster",
          "school_name",
          "anganwadi_name",
          "lastUpdated",
        ]
      : selectedTab === "anganwadi_wise"
      ? [
          "district",
          "project",
          "sector",
          "anganwadi_name",
          "total_students",
          "level1_students",
          "level2_students",
          "level3_students",
          "activated_users",
          "active_users",
          "smartphone_users",
          "non_smartphone_users",
          "lastUpdated",
        ]
      : selectedTab === "anganwadi_wise_performance"
      ? [
          "district",
          "project",
          "sector",
          "anganwadi_name",
          "year",
          "month",
          "week",
          "ts_0to1_users",
          "ts_0to1_avgTs",
          "ts_2to15_users",
          "ts_2to15_avgTs",
          "ts_16to30_users",
          "ts_16to30_avgTs",
          "ts_31to45_users",
          "ts_31to45_avgTs",
          "ts_45plus_users",
          "ts_45plus_avgTs",
          "lastUpdated",
        ]
      : null;

  const formatDate = (dateString) => {
    const currentDate = new Date();
    const sanitizedDate = dateString ? dateString.replace(/"/g, "").trim() : "";
    const isValidDateFormat = /^\d{2}-\d{2}-\d{4}$/.test(sanitizedDate);
    if (isValidDateFormat) {
      const [day, month, year] = sanitizedDate.split("-");
      return `${year}-${month}-${day}`;
    }
    const parsedDate = sanitizedDate ? new Date(sanitizedDate) : null;
    if (parsedDate && !isNaN(parsedDate)) {
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const day = String(parsedDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const processExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setFileCount(jsonData.length);

      // Extract headers from the first row
      const headers = jsonData[0];

      // Check for missing headers
      const missingHeaders = expectedHeaders.filter(
        (header) => !headers.includes(header)
      );

      if (missingHeaders.length) {
        toast.error(`Missing headers: ${missingHeaders.join(", ")}`);
        setFile(null);
        return;
      }

      // Process the sheet into JSON format
      const processedData = XLSX.utils.sheet_to_json(sheet).map((row) => ({
        ...row,
        lastUpdated: formatDate(row.lastUpdated), // Always format or use current date
      }));

      setExcelData(processedData);
      console.log("processedData", processedData);

      toast.success("File processed successfully!");
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSubmit = () => {
    if (!selectedTab || !file || !excelData) {
      toast.error("Please upload a file before submitting.");
      return;
    }

    setLoadingSave(true);

    switch (selectedTab) {
      case "dashboard":
        handleSaveApiCall(saveOverallDashboard, excelData, getOverallDashboard);
        break;
      case "dashboard_monthly":
        handleSaveApiCall(saveDashboardMonthly, excelData, getDashboardMonthly);
        break;
      case "remote_instructions_weekwise":
        handleSaveApiCall(
          saveRemoteInstructionsWeeklyData,
          excelData,
          getRemoteInstructionsWeeklyData
        );
        break;
      case "remote_instructions_monthwise":
        handleSaveApiCall(
          saveRemoteInstructionsMonthlyData,
          excelData,
          getRemoteInstructionsMonthlyData
        );
        break;
      case "monthly_unique":
        handleSaveApiCall(
          saveMonthlyUniqueUsers,
          excelData,
          getMonthlyUniqueUsers
        );
        break;
      case "whatsapp_chatbot_monthly":
        handleSaveApiCall(
          saveWhatsappBotMonthlyData,
          excelData,
          getWhatsappBotMonthlyData
        );
        break;
      case "whatsapp_chatbot_weekly":
        handleSaveApiCall(
          saveWhatsappBotWeeklyData,
          excelData,
          getWhatsappBotWeeklyData
        );
        break;
      case "school_wise":
        handleSaveApiCall(saveSchoolwiseData, excelData, getSchoolwiseData);
        break;
      case "school_wise_performance":
        handleSaveApiCall(
          saveSchoolwisePerformanceData,
          excelData,
          getSchoolwisePerformanceData
        );
        break;
      case "retention_metrics":
        handleSaveApiCall(
          saveRetentionMetricsData,
          excelData,
          getRetentionMetricsData
        );
        break;
      case "dist_blocks":
        handleSaveApiCall(saveStaticDistBlocks, excelData, getStaticDistBlocks);
        break;
      case "anganwadi_wise":
        handleSaveApiCall(
          saveAnganwadiwiseData,
          excelData,
          getAnganwadiwiseData
        );
        break;

      case "anganwadi_wise_performance":
        handleSaveApiCall(
          saveAnganwadiWisePerformanceData,
          excelData,
          getAnganwadiwisePerformanceData
        );
        break;

      default:
        toast.error("Invalid tab selected.");
        break;
    }
  };

  console.log("excel data---------->", excelData);

  //*------------------------------------------------------------------------------------------------
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "'Arial', sans-serif",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        maxWidth: "2000px",
        margin: "auto",
      }}
    >
      {/* Header */}
      <MuiHeader header="PRAKASAK Statics" />

      {/* Tab Selection */}
      <FormControl
        sx={{
          width: "220px",
          marginBottom: "20px",
          marginLeft: "2%",
        }}
        size="small"
      >
        <InputLabel id="tab-select-label">Select Tab</InputLabel>
        <Select
          labelId="tab-select-label"
          id="tab-select-label"
          value={selectedTab}
          onChange={handleTabChange}
          label="tab-select"
          style={{
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          {tabArray.map((tab, index) => (
            <MenuItem key={index} value={tab.value}>
              {tab.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedTab ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
            paddingBottom: "20px",
          }}
        >
          {/* Drag-and-Drop Area */}
          <div
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              width: "48%", // Adjust width for spacing
              maxWidth: "600px",
              border: "2px dashed #007bff",
              padding: "30px",
              textAlign: "center",
              backgroundColor: isDraggedOver ? "#e3f2fd" : "transparent",
              transition: "background-color 0.3s ease",
              borderRadius: "8px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <p
              style={{
                fontSize: "1.2rem",
                marginBottom: "15px",
                color: "#333",
                fontWeight: "bold",
              }}
            >
              {isDraggedOver
                ? "Drop the Excel file here..."
                : "Drag 'n' drop an Excel file here, or click to select one"}
            </p>

            <input
              type="file"
              accept=".xlsx"
              onChange={handleFileInputChange}
              style={{
                display: "none",
              }}
              id="fileUpload"
            />
            <label htmlFor="fileUpload">
              <Button
                variant="contained"
                component="span"
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "8px",
                }}
              >
                Select File
              </Button>
            </label>

            {file && (
              <p
                style={{
                  marginTop: "10px",
                  color: "#3498db",
                  fontWeight: "bold",
                }}
              >
                Selected file: {file.name}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div
            style={{
              width: "48%", // Adjust width for spacing
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {loadingSave ? (
              <CircularProgress style={{ color: "#007bff" }} />
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                style={{
                  backgroundColor: "#ff5722",
                  color: "#fff",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
                  padding: "12px 30px",
                  borderRadius: "8px",
                }}
              >
                Submit
              </Button>
            )}
          </div>
        </div>
      ) : null}

      {file && (
        <div>
          <Typography variant="h6">{file.name}</Typography>
          {/* Display count */}
          {fileCount && (
            <Typography
              variant="body1"
              style={{ marginTop: "10px", color: "#333" }}
            >
              Total Rows: {fileCount}
            </Typography>
          )}
          {loading && <CircularProgress />}
        </div>
      )}

      {/* Data Preview */}
      {excelData && (
        <div>
          <pre>{JSON.stringify(excelData, null, 2)}</pre>
        </div>
      )}

      {Array.isArray(allData) && allData.length > 0 ? (
        <div
          style={{
            marginTop: "20px",
            marginBottom: "40px",
            overflowX: "auto",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px",
                    backgroundColor: "#f2f2f2",
                    fontWeight: "bold",
                  }}
                >
                  Sl no.
                </th>
                {/* Render headers dynamically based on data type */}
                {selectedTab === "retention_metrics"
                  ? Object.keys(allData[0]?.retention || {}).map(
                      (month, index) => (
                        <th
                          key={index}
                          style={{
                            border: "1px solid #ddd",
                            padding: "12px",
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                          }}
                        >
                          {month.charAt(0).toUpperCase() + month.slice(1)}
                        </th>
                      )
                    )
                  : Object.keys(allData[0])
                      .filter((key) => key !== "retention") // Exclude retention for non-retention metrics
                      .map((key, index) => (
                        <th
                          key={index}
                          style={{
                            border: "1px solid #ddd",
                            padding: "12px",
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                          }}
                        >
                          {key === "lastUpdated" ? "Last Updated" : key}
                        </th>
                      ))}
              </tr>
            </thead>
            <tbody>
              {allData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "12px",
                      textAlign: "center",
                    }}
                  >
                    {rowIndex + 1}
                  </td>
                  {selectedTab === "retention_metrics"
                    ? Object.entries(row.retention || {}).map(
                        ([month, retentionValue], colIndex) => (
                          <td
                            key={colIndex}
                            style={{
                              border: "1px solid #ddd",
                              padding: "12px",
                              textAlign: "center",
                            }}
                          >
                            {retentionValue !== null ? retentionValue : "-"}
                          </td>
                        )
                      )
                    : Object.entries(row)
                        .filter(([key]) => key !== "retention") // Exclude retention for non-retention metrics
                        .map(([key, value], colIndex) => (
                          <td
                            key={colIndex}
                            style={{
                              border: "1px solid #ddd",
                              padding: "12px",
                              textAlign: "center",
                            }}
                          >
                            {key === "lastUpdated"
                              ? (() => {
                                  const date = new Date(value);
                                  const day = String(date.getDate()).padStart(
                                    2,
                                    "0"
                                  );
                                  const month = String(
                                    date.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = date.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()
                              : value}
                          </td>
                        ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : allData.length === 0 && excelData?.length === 0 ? (
        <p>No data available</p>
      ) : null}

      <ToastContainer />
    </div>
  );
};

export default PrakashakStatics;
